import React from "react";

import defaultImage from "assets/img/default-avatar.png";

class PictureUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: null,
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getPreviewUrl = this.getPreviewUrl.bind(this);
  }
  handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
      this.props.onImageChange(file, reader.result);
    };
    reader.readAsDataURL(file);
  }
  componentDidMount() {
    if(this.props.imagePreviewUrl){
      this.setState({imagePreviewUrl:this.props.imagePreviewUrl});
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }

  getPreviewUrl(){


    if(this.state.imagePreviewUrl){
      return this.state.imagePreviewUrl;
    }

    if(this.props.imagePreviewUrl){
      return this.props.imagePreviewUrl;
    }

    return defaultImage;

  }

  render() {
    return (
      <div className="picture-container">
        <div className="picture">
          <img
            src={this.getPreviewUrl()}
            className="picture-src"
            alt="..."
          />
          <input type="file" onChange={e => this.handleImageChange(e)} />
        </div>
        <h6 className="description">Choose Picture</h6>
      </div>
    );
  }
}

export default PictureUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/PictureUpload.jsx